import { render, staticRenderFns } from "./SignIn.vue?vue&type=template&id=36905d3d&"
import script from "./SignIn.vue?vue&type=script&lang=js&"
export * from "./SignIn.vue?vue&type=script&lang=js&"
import style0 from "./SignIn.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QForm,QInput,QBtn} from 'quasar'
component.options.components = Object.assign({QPage,QForm,QInput,QBtn}, component.options.components || {})
